module.exports = __webpack_public_path__ + "static/assets/b004dbd950e67608e195a92884c2a310.png";